import { Link, Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import ItemListPage from "./components/ItemList";
import ItemFormPage from "./components/ItemForm";
import ItemAppendPage from "./components/ItemAppend";
import { getUserDisplayName, isAuthenticated, startLogin, startLogout } from "./auth";
import { MoonIcon, SunIcon } from "./components/Icons";

export default function App() {
  const [userName, setUserName] = useState<string | null>(null);
  const [theme, setTheme] = useState<"light" | "dark">(() => {
    const stored = localStorage.getItem("shopping-list-theme");
    if (stored === "dark" || stored === "light") return stored;
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  });

  useEffect(() => {
    setUserName(getUserDisplayName());
  }, []);

  useEffect(() => {
    document.body.classList.toggle("theme-dark", theme === "dark");
    localStorage.setItem("shopping-list-theme", theme);
  }, [theme]);

  return (
    <div className="app-shell">
      <header className="header">
        <div>
          <h1>Shopping List</h1>
        </div>
        <div className="page-actions">
          <button
            type="button"
            className="theme-toggle"
            onClick={() => setTheme((prev) => (prev === "dark" ? "light" : "dark"))}
            aria-label="Toggle dark mode"
          >
            {theme === "dark" ? <MoonIcon ariaHidden /> : <SunIcon ariaHidden />}
            <span className="sr-only">Toggle theme</span>
          </button>
          {userName ? (
            <div className="login-pill" style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              <span>Welcome {userName}!</span>
              <button type="button" className="link-button" onClick={startLogout}>
                Sign out
              </button>
            </div>
          ) : (
            <button
              type="button"
              className="login-pill"
              onClick={() => {
                startLogin();
              }}
            >
              Sign in with Google
            </button>
          )}
        </div>
      </header>
      <Routes>
        <Route path="/" element={<ItemListPage />} />
        <Route path="/item" element={<ItemFormPage />} />
        <Route path="/item/:id" element={<ItemFormPage />} />
        <Route path="/append" element={<ItemAppendPage />} />
      </Routes>
    </div>
  );
}
